import { CategoryCoverageDto } from 'enrollment/queries/useBenefitCategoryQuery/types';
import {
  BenefitPlanDto,
  CoverageDto,
} from 'enrollment/queries/useBenefitPlansQuery/types';
import {
  PlanInfoResponseDto,
  PlanLevelCostDto,
} from 'enrollment/queries/usePlanInformationQuery/utils';
import { getPremiumStyled, RETURN_DISPLAY } from 'enrollment/utils';

export const getStyledPremiumCovLevels = (
  planLevelCosts: PlanLevelCostDto | undefined,
  coverageLevel: string,
  hideEmptyCost: boolean
) => {
  if (planLevelCosts) {
    const premium = planLevelCosts[coverageLevel]
      ? planLevelCosts[coverageLevel].subscriber_premium
      : null;

    if (!premium) {
      return '';
    }

    if (!hideEmptyCost || Number(premium) > 0) {
      return getPremiumStyled({
        premium: premium,
        valueOnly: RETURN_DISPLAY,
        tagName: 'div',
        dollarClasses: 'headline-2',
      });
    }
  } else {
    return '';
  }
};

export const getPremiumCovLevels = (
  planLevelCosts: PlanLevelCostDto | undefined,
  coverageLevel: string
) => {
  if (planLevelCosts) {
    const premium = planLevelCosts[coverageLevel]
      ? planLevelCosts[coverageLevel].subscriber_premium
      : null;

    return premium ? Number(premium) : 0;
  } else {
    return 0;
  }
};

export const getPremiumValue = (
  isDepSelect: boolean,
  plan: BenefitPlanDto,
  planInfoData: PlanInfoResponseDto | undefined,
  selectedCovLevel: string
) => {
  if (isDepSelect) {
    return Number(plan.subscriber_premium);
  } else {
    return getPremiumCovLevels(
      planInfoData?.data.plan_level_costs,
      selectedCovLevel
    );
  }
};

export const isCurrentPlan = (coveragePlanId?: number, orgPlanId?: number) => {
  if (coveragePlanId && orgPlanId) {
    return orgPlanId === coveragePlanId;
  } else {
    return false;
  }
};

export const getCurrentPlan = (
  coveragePlanId: number,
  plans: BenefitPlanDto[]
) => {
  const currentPlan = plans.find((plan) =>
    isCurrentPlan(coveragePlanId, plan.plan_id)
  );

  return currentPlan;
};

export const isElectedPlan = (
  coverage: CategoryCoverageDto | CoverageDto | undefined,
  planId: number,
  requestedDependentIds: number[] | undefined,
  selectedDependentIds: number[] | undefined
) => {
  return (
    isCurrentPlan(coverage?.org_plan_id, planId) &&
    requestedDependentIds?.toString() === selectedDependentIds?.toString() &&
    !coverage?.termination_date
  );
};
